import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { SERVICES, IMAGES } from "../data";

export default function Services() {
  return (
    <main data-testid="services-page" className="pt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-10 lg:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <span className="text-xs tracking-[0.25em] uppercase font-semibold text-[#A95C42]">
              What we build
            </span>
            <h1 className="font-serif-display text-5xl sm:text-6xl tracking-tight font-medium text-[#1E352F] mt-2">
              Services
            </h1>
            <p className="text-base text-[#4A5D54] mt-3 leading-relaxed">
              From flagging the first line to setting the last stone, we build
              natural-surface trails that fit the land and stand up to Montana
              seasons. Hand &amp; machine built — efficient machine work finished
              with hand-stacked rock and careful detail. No trail too big, no trail
              too small.
            </p>
            <div className="relative overflow-hidden rounded-sm border border-[#D1CFC7] mt-6 aspect-[4/3]">
              <img
                src={IMAGES.showcaseFir}
                alt="Old-growth Douglas fir forest"
                className="absolute inset-0 w-full h-full object-cover"
              />
            </div>
            <Link
              to="/quote"
              data-testid="services-quote-button"
              className="mt-6 inline-flex items-center gap-2 bg-[#2D4A3E] text-[#F8F7F4] px-6 py-3 rounded-sm font-medium hover:bg-[#1E352F] transition-colors duration-300"
            >
              Request a Quote <ArrowRight className="h-4 w-4" />
            </Link>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-5">
            {SERVICES.map((s, i) => (
              <motion.div
                key={s.title}
                data-testid={`service-card-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="rounded-sm border border-[#D1CFC7] bg-[#FFFFFF] p-7"
              >
                <span className="font-serif-display text-3xl text-[#7E9384]">
                  0{i + 1}
                </span>
                <h3 className="font-serif-display text-2xl text-[#1E352F] mt-2">
                  {s.title}
                </h3>
                <p className="text-sm text-[#4A5D54] mt-2 leading-relaxed">
                  {s.body}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
}
